export default "__VITE_ASSET__CFUssitX__"